import React from 'react';

export default function AddOns({ addOns }) {
  return <span className="fs-xs text-muted">(Add-ons: {addOns.map(({ label }) => label).join(', ')})</span>;
}
